<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      梦海站<br>
站点介绍<br>
梦海站位于深圳市南山区梦海大道与前湾一路交叉路口南侧，车站周边规划以商业、办公为主。车站为地下车站，地下一层为站厅层，地下二层为站台层，共设置2个出入口。车站设有自动扶梯、垂梯、公共洗手间等便民设施。车站以白色为主色调、立柱装饰及站厅中部天花吊顶大面积采用镜面材质，以蓝色条形装饰和灯带做点缀，呈现出海面波光粼粼的视觉效果。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:28	00:08	9号线	3分50秒	5分55秒<br>
文锦	06:21	23:01	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:30	00:08	9号线	4分25秒	5分55秒<br>
文锦	06:21	23:01	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:29	01:08	9号线	4分钟	5分55秒<br>
文锦	06:21	00:01	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
C出入口:<br>
梦海大道东侧、创新商务东街、梦工场街、公馆南街、前海运动公园<br><br>
D出入口:<br>
梦海大道西侧<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 深港创新中心（创新商务中心）<br>
M158、M418<br><br>
D出入口:<br>
公交站名： 梦海地铁站<br>
M158、M418<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>